import { adminHttpClient } from '../commons/adminHttpClient'

export type FamilyAllowanceForCurrentUserResponse = {
  allowance: number
}

const getFamilyAllowanceForCurrentUser = (): Promise<FamilyAllowanceForCurrentUserResponse> => {
  return adminHttpClient.get(`/Benefit/FamilyAllowanceForCurrentUser`)
}

export default getFamilyAllowanceForCurrentUser
